import { BaseService } from '../base';
import type { CnpjResponse } from './types';

type ServiceResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
};

const BASE_URL = import.meta.env.VITE_API_URL;

export class CnpjService extends BaseService {
  async getByCnpj(cnpj: string): Promise<ServiceResponse<CnpjResponse>> {
    const cleanCnpj = (cnpj ?? '').replace(/[^A-Z0-9]/gi, '').toUpperCase();

    if (cleanCnpj.length !== 14) {
      return { success: false, error: 'CNPJ inválido' };
    }

    try {
      const response = await this.get(
        `/portal/v1/services/cnpj/${encodeURIComponent(cleanCnpj)}`,
        {},
        BASE_URL
      );

      return await this.handleJsonResponse<CnpjResponse>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro ao consultar CNPJ',
      };
    }
  }
}

export const cnpjService = new CnpjService();

/**
 * Registration status considered active — matches `situacao_cadastral === 2`
 * (`ATIVA`) from the Brasil API / Receita Federal.
 */
export const CNPJ_ACTIVE_REGISTRATION_STATUS_CODE = 2;
export type { CnpjAddress, CnpjResponse } from './types';
